module.exports = __webpack_public_path__ + "img/english.1f4baade.png";